import { Routes, Route, Navigate, useLocation } from 'react-router';

/** `/app/tapi?task=&day=` → לוח הבקרה, עם ה-query (קישורים ממיילים, 05/10). */
function TapiRedirect(): JSX.Element {
  const { search } = useLocation();
  const q = new URLSearchParams(search);
  q.set('tab', 'queue');
  return <Navigate to={`/app/production-center?${q.toString()}`} replace />;
}

/** „לוח בקרה" הוחלף ב„מרכז מנהל ייצור" (אלי 11/10/2026) — הקישורים הישנים, עם ה-query. */
function ControlRedirect(): JSX.Element {
  const { search } = useLocation();
  return <Navigate to={`/app/production-center${search}`} replace />;
}
import { AuthProvider } from './auth/AuthContext.js';
// ── כל מסך בקובץ משלו (02/11/2026) ─────────────────────────────────────────
// המנכ״ל: „זמן העלאת האפליקציה בטלפון ארוך." כל המסכים למטה נטענים רק כשנכנסים
// אליהם — עמדה ברצפה, /field ומסך הכניסה כבר לא מורידים את קוד המשרד.
// ראו lib/lazyRoute.tsx; קובץ שנמחק בעדכון → „גרסה חדשה, טען מחדש" (ErrorBoundary).
import { lazyNamed, preloadMatched, RouteSuspense } from './lib/lazyRoute.js';
import { I18nProvider } from './i18n/index.js';
import { GreetingSplash } from './components/scan/GreetingSplash.js';
import { useAuth } from './auth/useAuth.js';
import { ApiAuthGuard } from './auth/ApiAuthGuard.js';
import { RequireAuth } from './auth/RequireAuth.js';
const AppShell = lazyNamed(() => import('./routes/app/AppShell.js'), 'AppShell');
const LoginPage = lazyNamed(() => import('./routes/app/LoginPage.js'), 'LoginPage');
const RecoverPage = lazyNamed(() => import('./routes/app/RecoverPage.js'), 'RecoverPage');
import { DashboardRoute, RoleLanding, RootRedirect } from './routes/app/RoleLanding.js';
const WarehousePage = lazyNamed(() => import('./routes/app/warehouse/WarehousePage.js'), 'WarehousePage');
const SubstitutePage = lazyNamed(() => import('./routes/app/SubstitutePage.js'), 'SubstitutePage');
const ProductionCenterPage = lazyNamed(() => import('./routes/app/ProductionCenterPage.js'), 'ProductionCenterPage');
import { useScreenVisit } from './lib/useScreenVisit.js';
const OperationsPage = lazyNamed(() => import('./routes/app/OperationsPage.js'), 'OperationsPage');
const ProductionBoardPage = lazyNamed(() => import('./routes/app/ProductionBoardPage.js'), 'ProductionBoardPage');
const MorningPage = lazyNamed(() => import('./routes/app/MorningPage.js'), 'MorningPage');
const ProductionUpdatesPage = lazyNamed(() => import('./routes/app/ProductionUpdatesPage.js'), 'ProductionUpdatesPage');
const ProjectsTreePage = lazyNamed(() => import('./routes/app/ProjectsTreePage.js'), 'ProjectsTreePage');
const TasksPage = lazyNamed(() => import('./routes/app/TasksPage.js'), 'TasksPage');
const WeeklyMeetingPage = lazyNamed(() => import('./routes/app/WeeklyMeetingPage.js'), 'WeeklyMeetingPage');
const InvoicesPage = lazyNamed(() => import('./routes/app/InvoicesPage.js'), 'InvoicesPage');
const ProjectEditPage = lazyNamed(() => import('./routes/app/projects/ProjectEditPage.js'), 'ProjectEditPage');
const ProjectCompletionPage = lazyNamed(() => import('./routes/app/projects/ProjectCompletionPage.js'), 'ProjectCompletionPage');
const UploadPage = lazyNamed(() => import('./routes/app/upload/UploadPage.js'), 'UploadPage');
const EmployeeBadgesPage = lazyNamed(() => import('./routes/app/EmployeeBadgesPage.js'), 'EmployeeBadgesPage');
const CardsPage = lazyNamed(() => import('./routes/app/CardsPage.js'), 'CardsPage');
const NfcCardsPage = lazyNamed(() => import('./routes/app/NfcCardsPage.js'), 'NfcCardsPage');
const EngineeringBoardPage = lazyNamed(() => import('./routes/app/EngineeringBoardPage.js'), 'EngineeringBoardPage');
const EngineeringSchedulePage = lazyNamed(() => import('./routes/app/EngineeringSchedulePage.js'), 'EngineeringSchedulePage');
const EngineeringMyWorkPage = lazyNamed(() => import('./routes/app/EngineeringMyWorkPage.js'), 'EngineeringMyWorkPage');
const EngineeringHoursPage = lazyNamed(() => import('./routes/app/EngineeringHoursPage.js'), 'EngineeringHoursPage');
const EngineeringLoadPage = lazyNamed(() => import('./routes/app/EngineeringLoadPage.js'), 'EngineeringLoadPage');
const ProjectQualityPage = lazyNamed(() => import('./routes/app/ProjectQualityPage.js'), 'ProjectQualityPage');
const EngineeringAssignPage = lazyNamed(() => import('./routes/app/EngineeringAssignPage.js'), 'EngineeringAssignPage');
const FinancePage = lazyNamed(() => import('./routes/app/FinancePage.js'), 'FinancePage');
const ManagementBoardPage = lazyNamed(() => import('./routes/app/ManagementBoardPage.js'), 'ManagementBoardPage');
const RepricePage = lazyNamed(() => import('./routes/app/RepricePage.js'), 'RepricePage');
const GanttPage = lazyNamed(() => import('./routes/app/GanttPage.js'), 'GanttPage');
const ProjectManagerBoardRoute = lazyNamed(() => import('./routes/app/ProjectManagerBoardPage.js'), 'ProjectManagerBoardRoute');
const DeliveryBoardPage = lazyNamed(() => import('./routes/app/DeliveryBoardPage.js'), 'DeliveryBoardPage');
const ProjectsDashboardPage = lazyNamed(() => import('./routes/app/dash/ProjectsDashboardPage.js'), 'ProjectsDashboardPage');
const EngineeringDashboardPage = lazyNamed(() => import('./routes/app/dash/EngineeringDashboardPage.js'), 'EngineeringDashboardPage');
const ProductionDashboardPage = lazyNamed(() => import('./routes/app/dash/ProductionDashboardPage.js'), 'ProductionDashboardPage');
const PurchasingDashboardPage = lazyNamed(() => import('./routes/app/dash/PurchasingDashboardPage.js'), 'PurchasingDashboardPage');
const ServiceDashboardPage = lazyNamed(() => import('./routes/app/dash/ServiceDashboardPage.js'), 'ServiceDashboardPage');
const FinanceDashboardPage = lazyNamed(() => import('./routes/app/dash/FinanceDashboardPage.js'), 'FinanceDashboardPage');
const CeoBoardPage = lazyNamed(() => import('./routes/app/CeoBoardPage.js'), 'CeoBoardPage');
const ImprovementRoomPage = lazyNamed(() => import('./routes/app/ImprovementRoomPage.js'), 'ImprovementRoomPage');
const OvertimePage = lazyNamed(() => import('./routes/app/OvertimePage.js'), 'OvertimePage');
const PerformanceDashboardPage = lazyNamed(() => import('./routes/app/dash/PerformanceDashboardPage.js'), 'PerformanceDashboardPage');
const LeadershipDashboardPage = lazyNamed(() => import('./routes/app/dash/LeadershipDashboardPage.js'), 'LeadershipDashboardPage');
const CatalogHomePage = lazyNamed(() => import('./routes/app/catalog/CatalogHomePage.js'), 'CatalogHomePage');
const CatalogManagePage = lazyNamed(() => import('./routes/app/catalog/ManagePage.js'), 'ManagePage');
const CatalogFromProjectPage = lazyNamed(() => import('./routes/app/catalog/FromProjectPage.js'), 'FromProjectPage');
const CatalogItemPage = lazyNamed(() => import('./routes/app/catalog/CatalogItemPage.js'), 'CatalogItemPage');
const CatalogEditPage = lazyNamed(() => import('./routes/app/catalog/CatalogEditPage.js'), 'CatalogEditPage');
const CustomerViewPage = lazyNamed(() => import('./routes/app/catalog/CustomerViewPage.js'), 'CustomerViewPage');
const CatalogPricesPage = lazyNamed(() => import('./routes/app/catalog/CatalogPricesPage.js'), 'CatalogPricesPage');
const CalculatorsHubPage = lazyNamed(() => import('./routes/app/catalog/calculators/CalculatorsHubPage.js'), 'CalculatorsHubPage');
const DriveCalculatorPage = lazyNamed(() => import('./routes/app/catalog/calculators/DriveCalculatorPage.js'), 'DriveCalculatorPage');
const GripperCalculatorPage = lazyNamed(() => import('./routes/app/catalog/calculators/GripperCalculatorPage.js'), 'GripperCalculatorPage');
const CalcPage = lazyNamed(() => import('./routes/app/catalog/calculators/CalcPage.js'), 'CalcPage');
import { RequireRole } from './auth/RequireRole.js';
import { CATALOG_ROLES } from './api/catalogRoles.js';
const ServicePage = lazyNamed(() => import('./routes/app/ServicePage.js'), 'ServicePage');
const InstallationsBoardPage = lazyNamed(() => import('./routes/app/InstallationsBoardPage.js'), 'InstallationsBoardPage');
const ShippingBoardPage = lazyNamed(() => import('./routes/app/ShippingBoardPage.js'), 'ShippingBoardPage');
const PurchasingPage = lazyNamed(() => import('./routes/app/PurchasingPage.js'), 'PurchasingPage');
const MyPurchaseRequestsPage = lazyNamed(() => import('./routes/app/MyPurchaseRequestsPage.js'), 'MyPurchaseRequestsPage');
const PurchaseQueuePage = lazyNamed(() => import('./routes/app/PurchaseQueuePage.js'), 'PurchaseQueuePage');
const QuestionsPage = lazyNamed(() => import('./routes/app/QuestionsPage.js'), 'QuestionsPage');
const SuppliersPage = lazyNamed(() => import('./routes/app/SuppliersPage.js'), 'SuppliersPage');
const ProductPricingPage = lazyNamed(() => import('./routes/app/ProductPricingPage.js'), 'ProductPricingPage');
const CustomersPage = lazyNamed(() => import('./routes/app/CustomersPage.js'), 'CustomersPage');
const ServiceDeskPage = lazyNamed(() => import('./routes/app/ServiceDeskPage.js'), 'ServiceDeskPage');
const OutboxPage = lazyNamed(() => import('./routes/app/OutboxPage.js'), 'OutboxPage');
const ProjectFilePage = lazyNamed(() => import('./routes/app/ProjectFilePage.js'), 'ProjectFilePage');
const ServiceTraceBoardPage = lazyNamed(() => import('./routes/app/ServiceTraceBoardPage.js'), 'ServiceTraceBoardPage');
const SupportPage = lazyNamed(() => import('./routes/app/SupportPage.js'), 'SupportPage');
const FinanceTVPage = lazyNamed(() => import('./routes/app/FinanceTVPage.js'), 'FinanceTVPage');
const SettingsPlaceholderPage = lazyNamed(() => import('./routes/app/SettingsPlaceholderPage.js'), 'SettingsPlaceholderPage');
const SettingsLayout = lazyNamed(() => import('./routes/app/settings/SettingsLayout.js'), 'SettingsLayout');
const RoutesPage = lazyNamed(() => import('./routes/app/settings/RoutesPage.js'), 'RoutesPage');
const EmployeesPage = lazyNamed(() => import('./routes/app/settings/EmployeesPage.js'), 'EmployeesPage');
const UsersPage = lazyNamed(() => import('./routes/app/settings/UsersPage.js'), 'UsersPage');
const PreferencesPage = lazyNamed(() => import('./routes/app/settings/PreferencesPage.js'), 'PreferencesPage');
const QuotesPage = lazyNamed(() => import('./routes/app/QuotesPage.js'), 'QuotesPage');
const QuotesReportPage = lazyNamed(() => import('./routes/app/QuotesReportPage.js'), 'QuotesReportPage');
const QuoteEditorPage = lazyNamed(() => import('./routes/app/QuoteEditorPage.js'), 'QuoteEditorPage');
const QuoteSignedPage = lazyNamed(() => import('./routes/app/QuoteSignedPage.js'), 'QuoteSignedPage');
const QmsPage = lazyNamed(() => import('./routes/app/QmsPage.js'), 'QmsPage');
const SalesDashboardPage = lazyNamed(() => import('./routes/app/dash/SalesDashboardPage.js'), 'SalesDashboardPage');
const ProfitabilityPage = lazyNamed(() => import('./routes/app/dash/ProfitabilityPage.js'), 'ProfitabilityPage');
const ScreenAccessPage = lazyNamed(() => import('./routes/app/settings/ScreenAccessPage.js'), 'ScreenAccessPage');
const ScreenUsagePage = lazyNamed(() => import('./routes/app/settings/ScreenUsagePage.js'), 'ScreenUsagePage');
const PermissionsPage = lazyNamed(() => import('./routes/app/settings/PermissionsPage.js'), 'PermissionsPage');
const NotificationRoutingPage = lazyNamed(() => import('./routes/app/settings/NotificationRoutingPage.js'), 'NotificationRoutingPage');
const MondaySyncPage = lazyNamed(() => import('./routes/app/settings/MondaySyncPage.js'), 'MondaySyncPage');
const ImportsPage = lazyNamed(() => import('./routes/app/settings/ImportsPage.js'), 'ImportsPage');
const ProfilesPage = lazyNamed(() => import('./routes/app/settings/ProfilesPage.js'), 'ProfilesPage');
const LabelRulesPage = lazyNamed(() => import('./routes/app/settings/LabelRulesPage.js'), 'LabelRulesPage');
const WhatsNewPage = lazyNamed(() => import('./routes/app/WhatsNewPage.js'), 'WhatsNewPage');
const CatalogSettingsPage = lazyNamed(() => import('./routes/app/settings/CatalogSettingsPage.js'), 'CatalogSettingsPage');
const DepartmentsPage = lazyNamed(() => import('./routes/app/settings/DepartmentsPage.js'), 'DepartmentsPage');
const ScanKioskPage = lazyNamed(() => import('./routes/scan/ScanKioskPage.js'), 'ScanKioskPage');
const LaserStationPage = lazyNamed(() => import('./routes/scan/LaserStationPage.js'), 'LaserStationPage');
const WorkerStationPage = lazyNamed(() => import('./routes/scan/WorkerStationPage.js'), 'WorkerStationPage');
const AssemblyKioskPage = lazyNamed(() => import('./routes/scan/AssemblyKioskPage.js'), 'AssemblyKioskPage');
const VehicleKioskPage = lazyNamed(() => import('./routes/scan/VehicleKioskPage.js'), 'VehicleKioskPage');
const TvFloorPage = lazyNamed(() => import('./routes/tv/TvFloorPage.js'), 'TvFloorPage');
const TvEngineeringPage = lazyNamed(() => import('./routes/tv/TvEngineeringPage.js'), 'TvEngineeringPage');
const VehiclesPage = lazyNamed(() => import('./routes/app/VehiclesPage.js'), 'VehiclesPage');
const CapacityPage = lazyNamed(() => import('./routes/app/CapacityPage.js'), 'CapacityPage');
const EngCapacityPage = lazyNamed(() => import('./routes/app/EngCapacityPage.js'), 'EngCapacityPage');
const RemnantStationPage = lazyNamed(() => import('./routes/scan/RemnantStationPage.js'), 'RemnantStationPage');
const SawStationPage = lazyNamed(() => import('./routes/scan/SawStationPage.js'), 'SawStationPage');
const CuttingQueuePage = lazyNamed(() => import('./routes/app/CuttingQueuePage.js'), 'CuttingQueuePage');
const RemnantsPage = lazyNamed(() => import('./routes/app/RemnantsPage.js'), 'RemnantsPage');
const NcKioskPage = lazyNamed(() => import('./routes/scan/NcKioskPage.js'), 'NcKioskPage');
const ChooseStationPage = lazyNamed(() => import('./routes/scan/ChooseStationPage.js'), 'ChooseStationPage');
const FinishingKioskV2Page = lazyNamed(() => import('./routes/scan/finishing/FinishingKioskV2Page.js'), 'FinishingKioskV2Page');
const FinishingKioskPage = lazyNamed(() => import('./routes/scan/FinishingKioskPage.js'), 'FinishingKioskPage');
const FieldApp = lazyNamed(() => import('./routes/field/FieldApp.js'), 'FieldApp');
const MachineByQrPage = lazyNamed(() => import('./routes/field/MachineByQrPage.js'), 'MachineByQrPage');
const HistoryPage = lazyNamed(() => import('./routes/app/HistoryPage.js'), 'HistoryPage');
const ActivityPage = lazyNamed(() => import('./routes/app/ActivityPage.js'), 'ActivityPage');
const ArchivePage = lazyNamed(() => import('./routes/app/ArchivePage.js'), 'ArchivePage');
const QualityGuidePage = lazyNamed(() => import('./routes/app/QualityGuidePage.js'), 'QualityGuidePage');
const FaultsBoardPage = lazyNamed(() => import('./routes/app/FaultsBoardPage.js'), 'FaultsBoardPage');
const NcReportPage = lazyNamed(() => import('./routes/app/NcReportPage.js'), 'NcReportPage');
const QualityRegistersPage = lazyNamed(() => import('./routes/app/QualityRegistersPage.js'), 'QualityRegistersPage');
const LearningLibraryPage = lazyNamed(() => import('./routes/app/LearningLibraryPage.js'), 'LearningLibraryPage');
const TracePage = lazyNamed(() => import('./routes/app/TracePage.js'), 'TracePage');
const InspectionReportPage = lazyNamed(() => import('./routes/app/InspectionReportPage.js'), 'InspectionReportPage');
const ReportBuilderPage = lazyNamed(() => import('./routes/app/ReportBuilderPage.js'), 'ReportBuilderPage');
const QrLabelsPage = lazyNamed(() => import('./routes/app/QrLabelsPage.js'), 'QrLabelsPage');
const IncomingBoardPage = lazyNamed(() => import('./routes/app/IncomingBoardPage.js'), 'IncomingBoardPage');
const LaserMaterialsPage = lazyNamed(() => import('./routes/app/LaserMaterialsPage.js'), 'LaserMaterialsPage');
const MachinesPage = lazyNamed(() => import('./routes/app/MachinesPage.js'), 'MachinesPage');
const AuditsPage = lazyNamed(() => import('./routes/app/AuditsPage.js'), 'AuditsPage');
const ManagementReviewPage = lazyNamed(() => import('./routes/app/ManagementReviewPage.js'), 'ManagementReviewPage');
const PortalApp = lazyNamed(() => import('./routes/portal/PortalApp.js'), 'PortalApp');
const NotFoundPage = lazyNamed(() => import('./routes/NotFoundPage.js'), 'NotFoundPage');
import { ErrorBoundary } from './components/ErrorBoundary.js';
import { SaveErrorBanner } from './components/ui/SaveErrorBanner.js';
import { ServerReconnect } from './components/ui/ServerReconnect.js';
import { StopScreen } from './components/scan/StopScreen.js';
const SettingsIndex = lazyNamed(() => import('./routes/app/settings/SettingsIndex.js'), 'SettingsIndex');
const IssuesPage = lazyNamed(() => import('./routes/app/IssuesPage.js'), 'IssuesPage');
const PhotoLinkPage = lazyNamed(() => import('./routes/photo/PhotoLinkPage.js'), 'PhotoLinkPage');


// The person's saved language lives on their user record; this hands it to the
// i18n provider once they are known, so a worker never re-picks it.
/**
 * רושם כניסה לכל מסך. רכיב ולא קריאה ישירה, כי `useLocation` דורש להיות
 * בתוך ה-Router — והוא מרונדר ריק.
 */
function ScreenVisitTracker(): null {
  useScreenVisit();
  return null;
}

function LanguageBridge({ children }: { children: React.ReactNode }): JSX.Element {
  const { user } = useAuth();
  return <I18nProvider initial={user?.preferredLanguage}>{children}</I18nProvider>;
}

// ── הנתיבים כקבוע (02/11/2026) — כדי שאפשר יהיה לטעון מראש את קבצי הנתיב
// של הכתובת הנוכחית, במקביל לבדיקת הכניסה. ראו preloadMatched.
const ROUTES = (
  <>
        <Route path="/" element={<RootRedirect />} />
        {/* Customer-facing portal — its own auth + layout, no staff shell. */}
        <Route path="/portal/*" element={<PortalApp />} />
        {/* צילום מהטלפון ב-QR (01/11/2026) — בלי כניסה, בלי מעטפת, בלי נתונים. */}
        <Route path="/photo/:token" element={<PhotoLinkPage />} />
        <Route path="/scan" element={<ScanKioskPage />} />
        <Route path="/scan/laser" element={<LaserStationPage />} />
        <Route path="/scan/station" element={<WorkerStationPage />} />
        {/* דף הרכבה מודפס → QR (אלי 02/11/2026). */}
        <Route path="/scan/assembly/:token" element={<AssemblyKioskPage />} />
        <Route path="/scan/issue" element={<Navigate to="/app/warehouse" replace />} />
        <Route path="/scan/remnants" element={<RemnantStationPage />} />
        <Route path="/scan/saw" element={<SawStationPage />} />
        <Route path="/scan/nc" element={<NcKioskPage />} />
        {/* „בחר עמדה" — מסך הנחיתה של משתמש הרצפה המשותף (26/09/2026). */}
        <Route path="/scan/choose" element={<ChooseStationPage />} />
        {/* קיוסק גמר — זיהוי, סריקה שמתחילה את השעון, ולוח „מי עובד על מה".
            העמדה נבחרת פעם אחת (או מגיעה ב-?departmentId=), ולכן אותו מסך
            משרת כל מחלקה שעובדת כך ולא רק גמר. */}
        {/* ── ⚠ הגמר החדש הוא עמדת העבודה, מ-24/09/2026 ─────────────────
            אלי, 23/09/2026 בערב, אחרי שראה אותו: „תפתח את הגמר החדש
            לעבודה. ותשאיר את הגמר הישן פתוח למקרה ויהיה בעיה. אבל הם
            יתחילו מחר לעבוד עם הגמר החדש."

            ⚠ ולכן **החלפה ולא מחיקה**: הישן נשאר על נתיב משלו כדלת
            חירום. מסך רצפה שנמחק ביום שהחדש מתגלה כשבור הוא מחלקה
            שעומדת — והמחיקה אינה דחופה, אפשר מחר. */}
        <Route path="/scan/finishing" element={<FinishingKioskV2Page />} />
        <Route path="/scan/finishing-old" element={<FinishingKioskPage />} />
        {/* הנתיב שבו אלי בדק אותו — נשאר עובד כדי שקישור שמור לא יישבר. */}
        <Route path="/scan/finishing2" element={<FinishingKioskV2Page />} />
        {/* ── קיוסק המחסן החדש ──────────────────────────────────────────
            אלי, 23/09/2026: „תשנה לגמרי את המסך כמו שעשית בלייזר… כל מה
            שצריך כדי שהמחסן יעבוד באופן יעיל מהשורש."

            ⚠ נתיב מקביל, ו-`/scan/issue` נשאר בדיוק כפי שהוא — אותו דפוס
            שאלי אישר בגמר: הוא רואה את החדש, ורק אז הישן זז. */}
        <Route path="/scan/warehouse" element={<Navigate to="/app/warehouse" replace />} />
        {/* דיווח נסיעה — reached by scanning the QR on the windscreen, so the
            vehicle is in the URL and the badge is the only identification. */}
        <Route path="/scan/vehicle/:token" element={<VehicleKioskPage />} />
        {/* מסך הרצפה בטלוויזיה (אלי 11/10/2026) — בלי כניסה, כמו הקיוסקים;
            נעול לכתובת המפעל ב-nginx. ?dept=<מחלקה> למסך של מחלקה אחת. */}
        <Route path="/tv/floor" element={<TvFloorPage />} />
        <Route path="/tv/engineering" element={<TvEngineeringPage />} />
        {/* עבודת שטח — the installation crew's own phone. Job code + badge,
            no staff account, so it sits outside the shell like the kiosks. */}
        <Route path="/field" element={<FieldApp />} />
        {/* ביקור אחזקה על מכונה אצל לקוח — אותו עולם כמו /field:
            טאבלט, אצבע, ובלי הנחה שיש קליטה. */}
        {/* U-1009-08: הצ׳קליסט נפתח מתוך כרטיס העבודה ב-/field (קוד או תג),
            ולא כמסך נפרד שדורש חשבון. קישורים ישנים — לדלת של /field. */}
        <Route path="/field/visit/:id" element={<Navigate to="/field" replace />} />
        <Route path="/field/visits/:employeeId" element={<Navigate to="/field" replace />} />
        {/* מדבקת ה-QR שעל המכונה מובילה לכאן. */}
        <Route path="/field/machine/:token" element={<MachineByQrPage />} />
        {/* לוח הקיר הישן הוחלף במסך הרצפה בטלוויזיה (אלי אישר v2 ב-11/10; נמחק 17/10/2026). */}
        <Route path="/app/board" element={<Navigate to="/tv/floor" replace />} />
        <Route
          path="/app/faults-board"
          element={
            <RequireAuth>
              <FaultsBoardPage />
            </RequireAuth>
          }
        />
        <Route
          path="/app/incoming-board"
          element={
            <RequireAuth>
              <IncomingBoardPage />
            </RequireAuth>
          }
        />
        <Route path="/app/warehouse-board" element={<Navigate to="/app/warehouse" replace />} />
        {/* Wall board — full screen, outside the app shell like the other boards. */}
        <Route
          path="/app/service-board"
          element={
            <RequireAuth>
              <ServiceTraceBoardPage />
            </RequireAuth>
          }
        />
        <Route
          path="/app/finance-tv"
          element={
            <RequireAuth>
              <FinanceTVPage />
            </RequireAuth>
          }
        />
        <Route path="/app/login" element={<LoginPage />} />
        {/* Where the CEO recovery link lands. Public by necessity — the token
            in the URL is the authentication — and it changes nothing without
            one. See auth/ceo-recovery.ts for why the old button is gone. */}
        <Route path="/app/recover" element={<RecoverPage />} />
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/app" element={<RoleLanding />} />
          <Route path="/app/dashboard" element={<DashboardRoute />} />
          {/* ── מסכים שהלוח החליף ──────────────────────────────────────
              אלי, 10/09/2026: „תחליף את הישן אחרי שעשית את כל הבדיקות
              וההתאמות והקישורים.“ הפניה ולא מחיקה: קישורים שמורים, מסמכים
              ישנים ולשוניות פתוחות ממשיכים לעבוד, והם נוחתים על הלשונית
              שעונה על אותה שאלה.

              „מבט מהיר“ הצהיר בעצמו שהוא „אותם נתוני סריקות והתקדמות של לוח
              הבקרה, מקובצים לכותרות“; „מי עובד על מה“ הוא אחד־עשר שורות
              שעוטפות שני רכיבים מהדשבורד; ו„תור עבודה“ הוא הלשונית עצמה,
              מוצג כפי שהוא. */}
          <Route path="/app/glance" element={<Navigate to="/app/production-center?tab=now" replace />} />
          <Route path="/app/operations" element={<OperationsPage />} />
          <Route path="/app/production" element={<ProductionBoardPage />} />
          {/* „הבוקר" — דף הבית של מנהל הייצור (אלי 19/10/2026). */}
          <Route path="/app/morning" element={<MorningPage />} />
          <Route path="/app/production-updates" element={<ProductionUpdatesPage />} />
          <Route path="/app/dispatch" element={<Navigate to="/app/production-center?tab=queue" replace />} />
          {/* ── לוח הבקרה המאוחד ─────────────────────────────────────────
              אלי, 09/09/2026: „לוח בקרה תפ״י ייצור וכל שאר הלוחות... לא
              מובנים בכלל.“ שלוש לשוניות, כפי שבחר: סכנות · עכשיו · תור.
              המסכים שהוא מחליף יופנו אליו רק אחרי בדיקה בדפדפן. */}
          <Route path="/app/control" element={<ControlRedirect />} />
          <Route path="/app/production-center" element={<ProductionCenterPage />} />
          {/* תפ״י הוא עכשיו החצי התחתון של לשונית „תור ושיבוץ“ — אלי: „שני
              חצאים של מסך אחד“. התור אומר מה דחוף, הלוח הופך את זה לשם. */}
          {/* ⚠ שומר את ה-query: מיילים ישנים מקשרים `/app/tapi?task=&day=` (05/10). */}
          <Route path="/app/tapi" element={<TapiRedirect />} />
          <Route path="/app/capacity" element={<CapacityPage />} />
          <Route path="/app/eng-capacity" element={<EngCapacityPage />} />
          <Route path="/app/engineering" element={<EngineeringBoardPage />} />
          <Route path="/app/engineering/my-work" element={<EngineeringMyWorkPage />} />
          <Route path="/app/engineering/hours" element={<EngineeringHoursPage />} />
          <Route path="/app/engineering/load" element={<EngineeringLoadPage />} />
          {/* אלי, 08/09/2026: „מבט איכות על פרויקט… כל הסעיפים, כל הדוחות,
              כל הפערים.“ קריאה בלבד — כל תיקון במסך שבו הסעיף נולד. */}
          <Route path="/app/project-quality" element={<ProjectQualityPage />} />
          <Route path="/app/engineering/assign" element={<EngineeringAssignPage />} />
          <Route path="/app/engineering/schedule" element={<EngineeringSchedulePage />} />
          <Route path="/app/finance" element={<FinancePage />} />
          {/* מסך ניהולי — הלו״ז והכלכלה של כל פרויקט על שורה אחת, ממוין לפי מה
              שדורש טיפול. Eli, 2026-08-31: "מסך ניהולי עם כל האינפורמציה של
              לו״ז וכלכלי לפרויקטים." It reads the cost board and the projects
              list; it computes nothing of its own. */}
          <Route path="/app/manage" element={<ManagementBoardPage />} />
          {/* לוח מנהל פרויקט and the finance screen's לוח עלויות tab were the
              same board twice, and the two reached the engine through different
              guards. One board now, on the tab. */}
          <Route path="/app/pm-board" element={<Navigate to="/app/finance?tab=board" replace />} />
          <Route path="/app/project" element={<ProjectManagerBoardRoute />} />
          <Route path="/app/gantt" element={<GanttPage />} />
          <Route path="/app/delivery" element={<DeliveryBoardPage />} />
          {/* דשבורדים — the analysis pages, deliberately apart from the screens
              people work in: a work queue with six charts on top of it stops
              being a queue, and the charts stop being read. */}
          <Route path="/app/dash/projects" element={<ProjectsDashboardPage />} />
          <Route path="/app/dash/engineering" element={<EngineeringDashboardPage />} />
          <Route path="/app/dash/production" element={<ProductionDashboardPage />} />
          <Route path="/app/dash/purchasing" element={<PurchasingDashboardPage />} />
          <Route path="/app/dash/service" element={<ServiceDashboardPage />} />
          <Route path="/app/dash/sales" element={<SalesDashboardPage />} />
          <Route path="/app/dash/profitability" element={<ProfitabilityPage />} />
          <Route path="/app/dash/finance" element={<FinanceDashboardPage />} />
          {/* מסך המנכ"ל — רווח והפסד, רצוי מול מצוי, וסבב דשבורדים לטלוויזיה. */}
          <Route path="/app/ceo" element={<CeoBoardPage />} />
          <Route path="/app/improvement-room" element={<ImprovementRoomPage />} />
          {/* שעות נוספות — the approval that puts the premium into a project cost.
              Three server routes and a daily notification existed with no screen. */}
          <Route path="/app/overtime" element={<OvertimePage />} />
          {/* דשבורד התכנון נמחק 26/09 (אלי): קרא את WorkerTask — 0 שורות — ו-0
              ביקורים ב-30 יום. קישור שמור ממשיך ללוח הייצור. */}
          <Route path="/app/dash/planning" element={<Navigate to="/app/production" replace />} />
          <Route path="/app/dash/performance" element={<PerformanceDashboardPage />} />
          {/* עמידה בזמנים, רווחיות ו-CDR לפי האנשים שמנהלים את העבודה. */}
          <Route path="/app/dash/leadership" element={<LeadershipDashboardPage />} />
          {/* תיק הפרויקט belongs to the project process — documents, customer
              approvals, drawings, equipment, as-built and procurement, from
              kickoff onward. Service is a separate screen: the call queue, with
              the machine context it needs to work a call. */}
          <Route path="/app/project-file" element={<ProjectFilePage />} />
          <Route path="/app/service" element={<ServiceDeskPage />} />
          {/* „ממתין לאישור שליחה" — כל מייל ללקוח עד שמאשר מאשר (אלי 09/10/2026). */}
          <Route path="/app/outbox" element={<OutboxPage />} />
          <Route path="/app/service-calls" element={<Navigate to="/app/service" replace />} />
          <Route path="/app/service-file" element={<Navigate to="/app/project-file" replace />} />
          {/* לוח ההתקנות (משימה 12c, 25/09/2026) — דף הבית של מנהל ההתקנות. רשימת
              עבודות השטח הישנה עברה ל-/jobs; קישורי ?order= מופנים אליה. */}
          <Route path="/app/installations" element={<InstallationsBoardPage />} />
          <Route path="/app/installations/jobs" element={<ServicePage />} />
          {/* לוח המשלוחים (25/09/2026). */}
          <Route path="/app/shipping" element={<ShippingBoardPage />} />
          <Route path="/app/vehicles" element={<VehiclesPage />} />
          <Route path="/app/reprice" element={<RepricePage />} />
          <Route path="/app/customers" element={<CustomersPage />} />
          <Route path="/app/purchasing" element={<PurchasingPage />} />
          <Route path="/app/my-purchases" element={<MyPurchaseRequestsPage />} />
          <Route path="/app/purchase-queue" element={<PurchaseQueuePage />} />
          <Route path="/app/questions" element={<QuestionsPage />} />
          <Route path="/app/suppliers" element={<SuppliersPage />} />
          {/* Receiving lives at the warehouse counter with issuing — same place,
              same people, one screen. The old link still lands there. */}
          <Route path="/app/receiving" element={<Navigate to="/app/warehouse" replace />} />
          <Route path="/app/product-pricing" element={<ProductPricingPage />} />
          {/* קטלוג מוצרים — what we have built, for the people selling the next one. */}
          {/* שלב א׳ של הקטלוג החדש (docs/catalog-spec.md). הדפים הישנים
              CatalogPage/CatalogEntryPage יוצאו מהניתוב; ‎/app/catalog/:id‎ הישן חוזר לבית. */}
          {/* מנהלת המשרד אינה נכנסת לקטלוג ולמחשבונים (אלי 07/10/2026) — דף „אין הרשאה" הרגיל. */}
          <Route path="/app/catalog" element={<RequireRole allowed={[...CATALOG_ROLES]}><CatalogHomePage /></RequireRole>} />
          <Route path="/app/catalog/item/:id" element={<RequireRole allowed={[...CATALOG_ROLES]}><CatalogItemPage /></RequireRole>} />
          {/* קטלוג שלב 3 — „עריכת מוצר" (מוק v2, אלי 12/10/2026): מנהל הנדסה / PM / סמנכ״ל / מנכ״ל; השרת מחליט סופית. */}
          <Route path="/app/catalog/item/:id/customer" element={<RequireRole allowed={[...CATALOG_ROLES]}><CustomerViewPage /></RequireRole>} />
          <Route path="/app/catalog/item/:id/edit"element={<RequireRole allowed={[...CATALOG_ROLES]}><CatalogEditPage /></RequireRole>} />
          {/* קטלוג C1-F3 — „מחירון" (אלי 07/10/2026). */}
          <Route path="/app/catalog/prices" element={<RequireRole allowed={[...CATALOG_ROLES]}><CatalogPricesPage /></RequireRole>} />
          {/* מחשבונים הנדסיים (אלי 07/10/2026) — לכל מי שרואה קטלוג; רק „הנעת מסוע" חי. */}
          {/* קטלוג שלב 2a (מוק v2, אלי 12/10/2026) — ניהול קטלוג + „מוצר מפרויקט" כמסך מלא. השרת שומר על כל פעולה. */}
          <Route path="/app/catalog/manage" element={<RequireRole allowed={[...CATALOG_ROLES]}><CatalogManagePage /></RequireRole>} />
          <Route path="/app/catalog/from-project" element={<RequireRole allowed={[...CATALOG_ROLES]}><CatalogFromProjectPage /></RequireRole>} />
          <Route path="/app/catalog/calculators" element={<RequireRole allowed={[...CATALOG_ROLES]}><CalculatorsHubPage /></RequireRole>} />
          <Route path="/app/catalog/calculators/drive" element={<RequireRole allowed={[...CATALOG_ROLES]}><DriveCalculatorPage /></RequireRole>} />
          <Route path="/app/catalog/calculators/pallet-gripper" element={<RequireRole allowed={[...CATALOG_ROLES]}><GripperCalculatorPage /></RequireRole>} />
          <Route path="/app/catalog/calculators/:kind" element={<RequireRole allowed={[...CATALOG_ROLES]}><CalcPage /></RequireRole>} />
          <Route path="/app/catalog/:id" element={<Navigate to="/app/catalog" replace />} />
          <Route path="/app/support" element={<SupportPage />} />
          <Route path="/app/projects" element={<ProjectsTreePage />} />
          {/* אלי, 13/09/2026: „תמיד דרישת רכש עוברת קודם כל במחסן.“ */}
          {/* המקום האחד של המחסן (אלי 05/10/2026, docs/warehouse-one-place-spec.md). */}
          {/* „בדיקת מלאי" ו„לניפוק" — תת-מסכים עם כתובת משלהם (אלי 31/10/2026). */}
          <Route path="/app/warehouse/*" element={<WarehousePage />} />
          {/* „יש משהו אחר במלאי" — אישור המהנדס מהמייל (מחסן שלב ב2). */}
          <Route path="/app/substitute" element={<SubstitutePage />} />
          <Route path="/app/warehouse-pick" element={<Navigate to="/app/warehouse" replace />} />
          {/* כיווני התצוגה החדשים של המחסן (30/09/2026) — במקביל, לא במקום. */}
          <Route path="/app/warehouse-next" element={<Navigate to="/app/warehouse" replace />} />
          <Route path="/app/tasks" element={<TasksPage />} />
          <Route path="/app/weekly-meeting" element={<WeeklyMeetingPage />} />
          <Route path="/app/invoices" element={<InvoicesPage />} />
          <Route path="/app/workers" element={<Navigate to="/app/production-center?tab=now" replace />} />
          {/* תקועים was a screen answering the question תפעול חי already
              answers as its first standby group. The old link still works and
              lands on that group, so nothing anybody bookmarked breaks. */}
          <Route path="/app/stuck" element={<Navigate to="/app/production-center?tab=dangers&kind=PART_STUCK" replace />} />
          {/* מגמות was four totals, the daily output chart and the
              per-department grid. The dashboard already drew the last two from
              the same endpoints; the totals moved there, and this link
              follows them. */}
          <Route path="/app/trends" element={<Navigate to="/app/dash/production" replace />} />
          <Route path="/app/quotes" element={<QuotesPage />} />
          {/* Registered BEFORE /:id — a static segment must not be read as an
              id, and "report" is exactly the word somebody would type. */}
          <Route path="/app/quotes/report" element={<QuotesReportPage />} />
          <Route path="/app/quotes/:id" element={<QuoteEditorPage />} />
          {/* „הגרסה שנחתמה" — the frozen copy written at the win (Eli 26/09). */}
          <Route path="/app/quotes/:id/signed" element={<QuoteSignedPage />} />
          <Route path="/app/quality-guide" element={<QualityGuidePage />} />
          <Route path="/app/qms" element={<QmsPage />} />
          <Route path="/app/upload" element={<UploadPage />} />
          <Route path="/app/employee-badges" element={<EmployeeBadgesPage />} />
          <Route path="/app/employee-cards" element={<NfcCardsPage />} />
          {/* כרטיסי מדף, פרויקט ופרופיל — מה שנתלה על הדבר עצמו. */}
          <Route path="/app/cards" element={<CardsPage />} />
          {/* מה דווח ומי דיווח — סימן הקריאה שבראש כל מסך נוחת כאן. */}
          <Route path="/app/issues" element={<IssuesPage />} />
          {/* אלי, 22/09/2026: „תמיד תהיה לי גישה ל-2 הקבצים ואוכל לראות את
              זה במערכת — רק אני כ-CEO ברשימות מה חדש ומעודכן." הסינון הוא
              בשרת: מי שאינו בעלים מקבל רק את מה שאלי שחרר. */}
          <Route path="/app/whats-new" element={<WhatsNewPage />} />
          <Route path="/app/settings" element={<SettingsLayout />}>
            {/* לא „routes“ קבוע — הלשונית הראשונה שהמשתמש הזה יכול לפתוח.
                ראה SettingsIndex: הדלת נפתחה ומאחוריה היה קיר. */}
            <Route index element={<SettingsIndex />} />
            <Route path="routes" element={<RoutesPage />} />
            <Route path="employees" element={<EmployeesPage />} />
            <Route path="departments" element={<DepartmentsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="permissions" element={<PermissionsPage />} />
            <Route path="screens" element={<ScreenAccessPage />} />
            {/* אלי, 10/09/2026: „להוסיף מדידה עכשיו, להחליט בעוד שבועיים.“
                יושב ליד „מי רואה איזה מסך“ כי זו אותה החלטה בדיוק — האחד
                אומר מי מורשה, והשני מי באמת נכנס. */}
            <Route path="screen-usage" element={<ScreenUsagePage />} />
            <Route path="notifications" element={<NotificationRoutingPage />} />
            <Route path="preferences" element={<PreferencesPage />} />
            <Route path="monday" element={<MondaySyncPage />} />
            <Route path="imports" element={<ImportsPage />} />
            <Route path="profiles" element={<ProfilesPage />} />
            <Route path="labels" element={<LabelRulesPage />} />
            <Route path="catalog" element={<CatalogSettingsPage />} />
            <Route path="*" element={<SettingsPlaceholderPage />} />
          </Route>
          <Route path="/app/projects/completion" element={<ProjectCompletionPage />} />
          <Route path="/app/projects/:number/edit" element={<ProjectEditPage />} />
          <Route path="/app/archive" element={<ArchivePage />} />
          <Route path="/app/history" element={<HistoryPage />} />
          <Route path="/app/activity" element={<ActivityPage />} />
          <Route path="/app/laser-materials" element={<LaserMaterialsPage />} />
          <Route path="/app/machines" element={<MachinesPage />} />
          <Route path="/app/audits" element={<AuditsPage />} />
          <Route path="/app/management-review" element={<ManagementReviewPage />} />
          <Route path="/app/cutting" element={<CuttingQueuePage />} />
          <Route path="/app/remnants" element={<RemnantsPage />} />
          {/* דוח הבוקר של מצב הטמעה אוחד ל„שעות חסרות" במרכז מנהל ייצור (אלי 17/10/2026). */}
          <Route path="/app/onboarding-report" element={<Navigate to="/app/production-center?tab=hours" replace />} />
          {/* Reports and registers. They used to sit OUTSIDE this shell, each
              with its own logo and title bar, because they print. That gave
              them no sidebar and no way back — Eli: "יש מסכים שלא ניתן
              לחזור מהם אחורה". Printing was never the reason: the shell hides
              its own chrome on paper and carries the brand there itself. */}
          <Route path="/app/nc-report" element={<NcReportPage />} />
          <Route path="/app/inspection-report" element={<InspectionReportPage />} />
          <Route path="/app/registers" element={<QualityRegistersPage />} />
          <Route path="/app/learning" element={<LearningLibraryPage />} />
          {/* „מכונות בשטח" נבלע במרשם „מערכות אצל לקוחות" (U-1009-01). */}
          <Route path="/app/service-machines" element={<Navigate to="/app/service?tab=systems" replace />} />
          <Route path="/app/trace" element={<TracePage />} />
          <Route path="/app/reports" element={<ReportBuilderPage />} />
          <Route path="/app/qr-labels" element={<QrLabelsPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
  </>
);

if (typeof window !== 'undefined') preloadMatched(ROUTES, window.location.pathname);

export default function App(): JSX.Element {
  return (
    // שפ-02: outermost, so a throw anywhere below shows a readable Hebrew screen
    // with a way out instead of the blank white page it used to leave behind.
    <ErrorBoundary>
    <AuthProvider>
      <LanguageBridge>
      <ApiAuthGuard />
      {/* Above the router, so it covers the office shell, the seven kiosks and
          the customer portal alike. A save refused on the shop floor is the one
          least likely to be reported and the most likely to be repeated. */}
      <SaveErrorBanner />
      {/* עדכון/נפילת רשת — פס „מתחברת מחדש לבד" ורענון אוטומטי (19/10/2026). */}
      <ServerReconnect />
      {/* עצירה אמיתית בסריקה → מסך מלא אדום בעמדות (אלי 21/10/2026). */}
      <StopScreen />
      {/* ── מדידת שימוש ──────────────────────────────────────────────────
          אלי, 10/09/2026: „להוסיף מדידה עכשיו, להחליט בעוד שבועיים.“ יושב
          **מעל** ה-Router כדי שיכסה גם את הקיוסקים ואת מסכי הקיר, ולא רק
          את מסכי המשרד — השאלה „איזה מסך מיותר“ נשאלה על כולם. */}
      <ScreenVisitTracker />
      <GreetingSplash />
      <RouteSuspense>
      <Routes>{ROUTES}</Routes>
      </RouteSuspense>
      </LanguageBridge>
    </AuthProvider>
    </ErrorBoundary>
  );
}
